import { useTranslation } from "react-i18next";

import { AgreementCreatorForm } from "@/modules/agreement/components/AgreementCreatorForm";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText } from "lucide-react";
import { useContractorData } from "../hooks";

interface ContractorAgreementCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ContractorAgreementCreateDialog = ({
  open,
  onOpenChange,
}: ContractorAgreementCreateDialogProps) => {
  const { t } = useTranslation();
  const contractor = useContractorData();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-4/5 max-w-xl bg-background">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5" />
            {t("agreements.createForm.titleForContractor", {
              contractorName: contractor.full_name,
            })}
          </DialogTitle>
        </DialogHeader>

        <AgreementCreatorForm
          inDialog={true}
          contractorId={contractor.id}
          contractorFullName={contractor.full_name}
          actions={[
            <DialogClose asChild>
              <Button variant="link">{t("common.cancel")}</Button>
            </DialogClose>,
          ]}
        />
      </DialogContent>
    </Dialog>
  );
};
